<template>
  <div class="area-setting-controller">
    <div class="container">
      <div class="ctl-panel-1">
        <div class="col-1">
          <area-setting-header></area-setting-header>
        </div>
        <div class="col-2">
          <tooltip tooltip-text="表示エリア指定を中断">
            <close-button @close="onClose"></close-button>
          </tooltip>
        </div>
      </div>
      <div class="ctl-panel-1">
        <div class="col-1">
          <playback-area
            :playbackRequestSettings="playbackRequestSettings"
          ></playback-area>
        </div>
        <div class="col-2">
          <playback-request-button
            :playbackRequestSettings="playbackRequestSettings"
            @playback-request="onPlaybackRequest"
          ></playback-request-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AreaSettingHeader from "./AreaSettingHeader";
import PlaybackArea from "./PlaybackArea.vue";
import PlaybackRequestButton from "./PlaybackRequestButton";
import CloseButton from "./CloseButton";
import Tooltip from "./Tooltip.vue";

const EMIT_EVENTS = {
  CLOSE: "close",
  PLAYBACK_REQUEST: "playback-request",
};

export default {
  name: "AreaSettingController",
  props: {
    playbackRequestSettings: {
      type: Object, // playbackRequestSettings
      default() {
        return {};
      },
    },
  },
  components: {
    AreaSettingHeader,
    PlaybackArea,
    CloseButton,
    Tooltip,
    PlaybackRequestButton,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onPlaybackRequest(event) {
      this.$emit(EMIT_EVENTS.PLAYBACK_REQUEST, event);
    },
    onClose(event) {
      this.$emit(EMIT_EVENTS.CLOSE, event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.area-setting-controller {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 2;
  width: 60vw;
  max-width: 800px;
  max-height: 112px;

  .container {
    width: 100%;
    height: 100%;
    background-color: $aisea-white;
    padding: 14px 20px;

    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 10px;

    .ctl-panel-1 {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      align-self: stretch;

      .col-1 {
        display: flex;
        align-items: center;
        gap: 25px;
        height: 36px;
      }
      .col-2 {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        align-self: stretch;
        gap: 30px;
      }
    }
  }
}
</style>
